// Fix Rebuy Smart Cart variant display with metafields
(function () {
  function updateRebuyVariants() {
    const variantElements = document.querySelectorAll('.rebuy-cart__flyout-item-variant-title[data-variant-id]');

    if (variantElements.length === 0 || !window.getVariantDisplayTitle) return;

    variantElements.forEach((element) => {
      const variantId = element.getAttribute('data-variant-id');
      const currentTitle = element.textContent.trim();

      if (variantId) {
        const newTitle = window.getVariantDisplayTitle(variantId, currentTitle);

        if (newTitle && newTitle !== currentTitle) {
          element.textContent = newTitle;
        } else if (newTitle === currentTitle) {
          console.log('[Rebuy Fix] Variant', variantId, 'already has correct title:', currentTitle);
        } else {
          console.log('[Rebuy Fix] No mapping found for variant', variantId, '- keeping title:', currentTitle);
        }
      }
    });
  }

  // Run after Rebuy renders or cart updates - with multiple retries
  let updateTimeout;
  const observer = new MutationObserver(() => {
    clearTimeout(updateTimeout);
    updateTimeout = setTimeout(() => {
      const cart = document.querySelector('.rebuy-cart__flyout--visible');
      if (cart) {
        updateRebuyVariants();
        // Retry a few more times to catch late-rendering elements
        setTimeout(updateRebuyVariants, 500);
        setTimeout(updateRebuyVariants, 1000);
      }
    }, 300);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });

  // Listen for Rebuy cart events
  if (window.Rebuy) {
    window.Rebuy.SmartCart.on('cart.change', function () {
      setTimeout(updateRebuyVariants, 300);
      setTimeout(updateRebuyVariants, 600);
      setTimeout(updateRebuyVariants, 1000);
    });
  }

  // Also listen for fetch requests (when items are added to cart)
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const promise = originalFetch.apply(this, args);
    const url = args[0];

    // Check if it's a cart-related request
    if (typeof url === 'string' && (url.includes('/cart/') || url.includes('cart.js'))) {
      promise.then(() => {
        setTimeout(updateRebuyVariants, 500);
        setTimeout(updateRebuyVariants, 1000);
        setTimeout(updateRebuyVariants, 1500);
      });
    }

    return promise;
  };

  // Initial check
  setTimeout(updateRebuyVariants, 1000);
})();
